import { useLive } from './useLive.js'
import { useSafeLocalStorage } from './useSafeLocalStorage.js'

const isVotesShape = (v: Record<string, number>) =>
  typeof v === 'object' && v !== null && !Array.isArray(v)

export const useVotes = () => {
  const { name, votingRegion } = useLive()
  const key = `2026votes-${name ?? 'unknown'}-${votingRegion?.code ?? 'unknown'}`
  return useSafeLocalStorage<Record<string, number>>(key, {}, isVotesShape)
}
